<script>
    export default {
        name: "CalcPlacesDimensionMixin",

        methods: {
            calcWeight(places) {
                let result = 0;
                places.forEach(place => {
                    result += place.dimension.weight;
                });
                return Math.round(result / 10) / 100;
            },

            calcVolume(places) {
                let result = 0;
                places.forEach(place => {
                    result += place.dimension.width * place.dimension.height * place.dimension.depth;
                });
                return Math.round(result / 1000000) / 1000;
            },
        },
    }
</script>